import React, { useState } from "react";
import { Collapse } from "@material-ui/core";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export default function StageTaskSelector({ budgetStructure, onSelectTask }) {
  const [expandedStages, setExpandedStages] = useState({});

  const toggleStage = (stageId) => {
    setExpandedStages(prev => ({
      ...prev,
      [stageId]: !prev[stageId]
    }));
  };

  const renderStagesAccordion = (stagesData) => {
    if (!Array.isArray(stagesData)) return null;

    return stagesData.map(stage => {
      // 1. Hide if excluded from field ops
      if (stage.exclude_from_field_ops === true) return null;

      // 2. Check if this stage is attribution level
      const isAttributionLevel = stage.is_attribution_level === true;

      const hasChildren = !isAttributionLevel && ((stage.stages && stage.stages.length > 0) || (stage.tasks && stage.tasks.length > 0));
      const isExpanded = !!expandedStages[stage.id];
      const taskCount = stage.tasks ? stage.tasks.length : 0;

      return (
        <div key={stage.id} className="border-bottom py-1" style={{ fontSize: "0.95rem" }}>
          <div
            className="d-flex align-items-center justify-content-between py-2 px-3 fw-semibold cursor-pointer"
            onClick={() => {
              if (isAttributionLevel) {
                onSelectTask(stage.id);
              } else {
                toggleStage(stage.id);
              }
            }}
            style={{ backgroundColor: "#f8f9fa", borderRadius: "4px", margin: "2px 0" }}
          >
            <div className="d-flex align-items-center">
              {!isAttributionLevel && hasChildren && (isExpanded ? <KeyboardArrowDownIcon className="me-1 text-muted" /> : <KeyboardArrowRightIcon className="me-1 text-muted" />)}
              <span>{stage.name}</span>
            </div>
            {isAttributionLevel ? (
              <span className="small bg-light border px-2 py-0.5 rounded text-primary fw-semibold">Select Section</span>
            ) : (
              taskCount > 0 && <span className="text-muted small">{taskCount} tasks</span>
            )}
          </div>

          {!isAttributionLevel && (
            <Collapse in={isExpanded}>
              <div className="ps-4">
                {/* Render Nested Stages */}
                {stage.stages && stage.stages.length > 0 && renderStagesAccordion(stage.stages)}

                {/* Render Nested Tasks */}
                {stage.tasks && stage.tasks.length > 0 && stage.tasks.map(task => (
                  <div
                    key={task.id}
                    onClick={() => onSelectTask(task.id)}
                    className="py-2 px-3 border-bottom cursor-pointer hover-bg-light text-primary d-flex align-items-center justify-content-between"
                    style={{ transition: "background 0.2s" }}
                  >
                    <div className="d-flex align-items-center">
                      <span style={{ fontWeight: "500" }}>{task.name || 'Unnamed Task'}</span>
                      {(task.proposal_status || task.optionProposalStatus) && (task.proposal_status || task.optionProposalStatus) !== 'APPROVED' && (
                        <span className="badge bg-warning text-dark ms-1" style={{ fontSize: '0.65em' }}>{task.proposal_status || task.optionProposalStatus}</span>
                      )}
                    </div>
                    <span className="small bg-light border px-2 py-0.5 rounded text-muted">Select</span>
                  </div>
                ))}
              </div>
            </Collapse>
          )}
        </div>
      );
    });
  };

  return (
    <div className="border rounded" style={{ maxHeight: "400px", overflowY: "auto", display: "block" }}>
      {budgetStructure.length === 0 ? (
        <div className="text-center text-muted py-4">No tasks found for this project.</div>
      ) : (
        renderStagesAccordion(budgetStructure)
      )}
    </div>
  );
}
